var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormSidebar',{attrs:{"form":_vm.form,"header":_vm.header,"is-a-b-test-enabled":_vm.isABTestEnabled,"form-name":_vm.formName},on:{"closeFormSidebar":_vm.closeFormSidebar}})
}
var staticRenderFns = []

export { render, staticRenderFns }